import React from 'react';
import { Row, HeadingText, Icon } from '@paypalcorp/pp-react';
import { Link } from '@paypalcorp/pp-react-links';
import style from './categoryTiles.less';
import * as analytics from '../../lib/analytics';

const CategoryTileImageBG = {
  textAlign: 'center',
  position: 'relative',
  width: '64px',
  height: '64px',
  borderRadius: '100px',
  backgroundColor: '#FAF8F5',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const CATEGORY_SPOT = {
  1004: 'wildlife',
  1001: 'culture',
  1011: 'children',
  1006: 'justice',
  1009: 'disaster-relief',
  1007: 'business',
  1003: 'environment',
  1005: 'health',
  1008: 'hunger',
  1012: 'human-services',
  1013: 'international',
  1017: 'military',
  1015: 'grants',
  1018: 'spirituality',
  1002: 'education',
  1016: 'science',
  1014: 'community',
  1010: 'sports',
  1019: 'general-support',
  1020: 'family-support',
  1021: 'memorials',
  1022: 'social-justice',
};

export default class extends React.Component {
  static defaultProps = {};

  constructor(props) {
    var initialState = {
      isMobile: false,
      isVisible: false,
      isOnShowSent: false,
    };

    super(props);
    this.state = initialState;
    this.intersectionObserver = null;
    this.container = null;
  }

  handleKeyPressCategoryTile(e, category) {
    if (e.key === 'Enter') {
      this.handleCategoryClick(category);
      window.open(
        `${this.props.coBrand}?category=${category}&type=${this.props.type}`,
        '_blank'
      );
    }
  }

  handleCategoryClick = (category) => {
    location.href = `${this.props.coBrand}?category=${category}&type=${this.props.type}`;
    analytics.trackLinkWithData(
      'CategoryTile',
      this.props.fptiInfo.pgrp,
      this.props.fptiInfo.page,
      { category },
      'link'
    );

    analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_PRESSED, {
      e: 'cl',
      tile_id: category,
      link_name: 'view',
      state: '',
      ...this.mapTileFPTIInfo('click', 8),
    });
  };

  mapFptiInfo = (eventType, fptiModule) => {
    return {
      e: eventType === 'impression' ? 'im' : 'av',
      state: eventType === 'impression' ? 'populated' : 'loaded',
      item_name: 'dw_giving',
      scope: 'module',
      account_type: this.props.authState === 'ANONYMOUS' ? 'guest' : 'member',
      acct_cntry: this.props.contentCountry,
      card_type: fptiModule,
      tile_id: fptiModule,
      lcid: '-', // TODO Check how to get the lcid
      order: 8,
      module: fptiModule,
    };
  };

  mapTileFPTIInfo = (eventType, order) => {
    return {
      e: eventType === 'impression' ? 'im' : 'av',
      state: eventType === 'impression' ? 'populated' : 'loaded',
      item_name: 'dw_giving',
      scope: 'tile',
      account_type: this.props.authState === 'ANONYMOUS' ? 'guest' : 'member',
      acct_cntry: this.props.contentCountry,
      card_type: 'category',
      lcid: '-',
      order,
      tile_id_typ: 'category_id',
      module: 'browse_by_category',
    };
  };

  componentDidMount() {
    this.intersectionObserver = new window.IntersectionObserver((entries) => {
      entries.forEach((entry) =>
        this.setState({ isVisible: entry.isIntersecting })
      );
    }, {});
    if (this.container) {
      this.intersectionObserver.observe(this.container);
    }

    const { authState } = JSON.parse(
      document.getElementById('data-props').innerHTML
    );
    const { country: contentCountry } = JSON.parse(
      document.getElementById('data-locale').innerHTML
    );

    analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_LOADED, {
      ...this.mapFptiInfo('loaded', 'browse_by_category'),
    });

    if (/Android|webOS|iPhone|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.setState({
        isMobile: true,
      });
    }

    const categoryTiles = this.getCategoryTiles();
    categoryTiles.map((category, index) => {
      analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_LOADED, {
        tile_id: category.id,
        ...this.mapTileFPTIInfo('loaded', index),
      });
    });
  }

  componentWillUnmount() {
    if (this.intersectionObserver && this.container) {
      this.intersectionObserver.disconnect();
    }
  }

  getCategoryTiles() {
    const categoryTiles =
      this.props.type === 'fundraisers' || this.props.type === 'all'
        ? this.props.fundraiserCategories || []
        : this.props.categories || [];
    return categoryTiles;
  }
  renderCategoryTiles = () => {
    const type =
      this.props.type === 'fundraisers' || this.props.type === 'all'
        ? 'fundraiser-'
        : '';
    const maxTextLength = this.props.maxTextLength || 30;

    const categoryTiles = this.getCategoryTiles();

    const xlColToUse = categoryTiles.find(
      (category) =>
        this.props.i18n(`label.${type}category-${category.id}`).length >
        maxTextLength
    )
      ? 'col-xl-4'
      : 'col-xl-3';

    return categoryTiles.map((category, index) => {
      const categoryName = this.props.i18n(
        `label.${type}category-${category.id}`
      );
      return (
        <div
          className={`col-xs-12 col-sm-6 col-md-4 col-lg-4 ${xlColToUse} cardCategorySelect`}
          key={index}
          tabIndex='0'
          role='link'
          onKeyDown={(e) => this.handleKeyPressCategoryTile(e, category.id)}
          onClick={this.handleCategoryClick.bind(this, category.id)}
        >
          <Link
            onClick={this.handleCategoryClick.bind(this, category.name)}
            theme='v2'
          >
            <div className={'cardCategoryTiles'}>
              <div className={'cardCategoryContent'}>
                <div style={CategoryTileImageBG}>
                  <Icon
                    name={CATEGORY_SPOT[category.id]}
                    alt={categoryName}
                    size='md'
                    color='sysColorAccent1Main'
                  />
                </div>
                {/* hidden from readers to avoid duplicate from the Spot alt */}
                <div aria-hidden='true' className={style.categoryTileName}>
                  {categoryName}
                </div>
              </div>
            </div>
          </Link>
        </div>
      );
    });
  };

  render() {
    if (this.state.isVisible && !this.state.isOnShowSent) {
      this.setState({ isOnShowSent: true });
      analytics.instance.recordEvent(analytics.events.DW_GIVING_MODULE_SHOWN, {
        ...this.mapFptiInfo('impression', 'browse_by_category'),
      });

      const categoryTiles = this.getCategoryTiles();
      categoryTiles.forEach((category, index) =>
        analytics.instance.recordEvent(analytics.events.DW_GIVING_TILE_SHOWN, {
          tile_id: category.id,
          ...this.mapTileFPTIInfo('impression', index),
        })
      );
    }
    return (
      <div
        id={this.props.id}
        className={style.charityCategories}
        ref={(div) => (this.container = div)}
      >
        <div className={style.categoryTileRow}>
          <HeadingText as='h3' size='sm' className={'card_heading'}>
            {this.props.i18n('label.browse-by-category')}
          </HeadingText>
          <Row>{this.renderCategoryTiles()}</Row>
        </div>
      </div>
    );
  }
}
